// extracted by mini-css-extract-plugin
export default {"field-wrap":"stripe-credit-card-form_field-wrap__UZKq0","error":"stripe-credit-card-form_error__bVVtK","submit-button":"stripe-credit-card-form_submit-button__6s42x"};